const readableColors = {
    0: '4a78b3',
    1: '98caab',
    2: '8f0113',
    3: 'f6b36e',
    4: 'a60369',
    5: 'cb6873',
    6: '7ebec2',
    7: 'c9018f',
    8: '72348c',
    9: '46670f',
    10: 'ad9df0',
    11: '746706',
    12: '0b8eb3',
    13: 'aa1c63',
    14: 'f38cc1',
    15: 'a5dc78',
    16: 'd997c1',
    17: 'a26a89',
    18: 'd4458F',
    19: '0dfcbf',
    20: '9fe17c',
    21: '581410',
    22: '22af97',
    23: '11d1dd',
    24: 'dcb308',
    25: 'f1b581',
    26: 'c6d3b7',
    27: '17f6ae',
    28: 'aab5d1',
    29: '6f7a64',
    30: '716a40',
    31: '22af97',
    32: '9f5444',
    33: '5d7af6',
    34: '01c87e',
    35: '414d6e',
    36: 'f4f9ab',
    37: 'bda716',
    38: '6c8afc',
    39: '9e79a5',
    40: '1fe058',
    41: 'e62f3c',
    42: '527b71',
    43: 'dad825',
    44: '162f72',
    45: '0f0f50',
    46: '73f660',
    47: 'eef24b',
    48: 'cc1d84',
    49: 'c483fb',
    50: 'bdeacd',
    51: 'e7673e',
    52: '7ce8c2',
    53: 'f7ecf9',
    54: '7ed4ee',
    55: 'dc863a',

}

export {readableColors}